import React, { useState, useEffect, useRef } from 'react';
import { 
  LayoutDashboard, Video, Palette, Globe, Plus, Trash2, Edit2, Check, X, Loader, 
  Monitor, MessageSquare, Lock, Image as ImageIcon, Newspaper, Eye, Users, 
  RefreshCw, LogOut, Link as LinkIcon, Settings, Bold, Italic, List,
  ArrowUp, ArrowDown, Type, LayoutTemplate, FileVideo, Facebook, Instagram, 
  Twitter, Youtube, Mail, Phone, MapPin, ChevronDown, ChevronUp, Shield, 
  TrendingUp, Smartphone, Clock, FileText, Film, Calendar, User, Tag,
  ExternalLink, DollarSign, AlertCircle, CheckCircle, Hourglass, Globe2, Save,
  AlertTriangle, Trophy, Briefcase, Send, XCircle, FileClock, Archive, PlayCircle, Clapperboard, Award, Sparkles,
  Users2, Download, Copy, GripVertical, Wand2, EyeOff
} from 'lucide-react';

// --- أيقونة تيك توك مخصصة ---
const TikTokIcon = ({ size = 18, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}>
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

// --- أنماط CSS (محدثة لتشمل السحب والإفلات) ---
const adminStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Lato:wght@300;400;700&display=swap');
  :root { --primary: #F97316; --bg-dark: #0B0F19; --border: rgba(255, 255, 255, 0.08); --text-muted: #9CA3AF; }
  * { box-sizing: border-box; outline: none; }
  body { margin: 0; background-color: var(--bg-dark); color: #F3F4F6; font-family: 'Cairo', sans-serif; overflow-x: hidden; }
  
  .admin-layout { display: flex; min-height: 100vh; }
  .sidebar { width: 260px; background: #0F172A; border-left: 1px solid var(--border); display: flex; flex-direction: column; padding: 20px; position: fixed; right: 0; height: 100vh; z-index: 100; overflow-y: auto; }
  .main-content { flex: 1; padding: 40px; margin-right: 260px; background: radial-gradient(circle at top left, #1e293b 0%, #0B0F19 100%); min-height: 100vh; }
  
  .nav-item { display: flex; align-items: center; gap: 12px; padding: 12px 15px; margin-bottom: 8px; border-radius: 10px; cursor: pointer; color: var(--text-muted); transition: 0.3s; font-weight: 600; }
  .nav-item:hover, .nav-item.active { background: var(--primary); color: white; box-shadow: 0 4px 15px rgba(249, 115, 22, 0.3); }
  
  .card { background: rgba(30, 41, 59, 0.5); border: 1px solid var(--border); border-radius: 16px; padding: 25px; margin-bottom: 25px; backdrop-filter: blur(10px); }
  .stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 20px; margin-bottom: 30px; }
  .stat-card { background: linear-gradient(135deg, rgba(30, 41, 59, 0.8), rgba(15, 23, 42, 0.9)); border: 1px solid var(--border); border-radius: 16px; padding: 25px; display: flex; align-items: center; gap: 20px; position: relative; overflow: hidden; }
  .stat-card::after { content: ''; position: absolute; top: -50%; right: -50%; width: 100px; height: 100px; background: var(--primary); filter: blur(80px); opacity: 0.1; }
  
  .input-group { margin-bottom: 20px; }
  .label { display: block; font-size: 0.9rem; color: var(--text-muted); margin-bottom: 8px; font-weight: bold; }
  .input { width: 100%; background: rgba(0, 0, 0, 0.3); border: 1px solid var(--border); padding: 12px; border-radius: 8px; color: #fff; transition: 0.3s; font-family: inherit; }
  .input:focus { border-color: var(--primary); box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.2); }
  
  .btn { padding: 12px 24px; border-radius: 8px; border: none; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; gap: 8px; transition: 0.3s; }
  .btn-primary { background: var(--primary); color: white; }
  .btn-danger { background: rgba(239, 68, 68, 0.2); color: #EF4444; border: 1px solid rgba(239, 68, 68, 0.3); }
  .btn-secondary { background: rgba(255,255,255,0.05); color: white; border: 1px solid var(--border); }
  .btn-icon { padding: 8px; border-radius: 50%; cursor: pointer; border: none; display: flex; align-items: center; justify-content: center; transition: 0.2s; }
  .btn-ai { background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%); color: white; border: none; padding: 5px 12px; border-radius: 20px; font-size: 0.75rem; cursor: pointer; display: inline-flex; align-items: center; gap: 5px; box-shadow: 0 4px 10px rgba(168, 85, 247, 0.3); transition: 0.3s; }
  .btn-ai:hover { transform: translateY(-2px); box-shadow: 0 6px 15px rgba(168, 85, 247, 0.5); }
  .btn-ai:disabled { opacity: 0.6; cursor: wait; }

  .section-item { display: flex; align-items: center; justify-content: space-between; background: rgba(255,255,255,0.03); padding: 15px; border-radius: 10px; margin-bottom: 10px; border: 1px solid var(--border); }
  .section-badge { font-size: 0.7rem; padding: 2px 8px; border-radius: 4px; margin-left: 10px; }
  .badge-core { background: rgba(59, 130, 246, 0.2); color: #60A5FA; }
  .badge-custom { background: rgba(34, 197, 94, 0.2); color: #4ADE80; }

  .chart-container { display: flex; align-items: flex-end; gap: 8px; height: 120px; margin-top: 20px; padding-bottom: 10px; border-bottom: 1px solid var(--border); }
  .chart-bar { flex: 1; background: var(--primary); border-radius: 4px 4px 0 0; opacity: 0.7; transition: 0.4s; cursor: pointer; position: relative; }
  .chart-bar:hover { opacity: 1; filter: brightness(1.2); }
  .chart-bar::before { content: attr(data-value); position: absolute; top: -25px; left: 50%; transform: translateX(-50%); font-size: 0.7rem; color: var(--primary); opacity: 0; transition: 0.3s; }
  .chart-bar:hover::before { opacity: 1; }

  .switch { position: relative; display: inline-block; width: 50px; height: 24px; }
  .switch input { opacity: 0; width: 0; height: 0; }
  .slider { position: absolute; cursor: pointer; inset: 0; background-color: #334155; transition: .4s; border-radius: 34px; }
  .slider:before { position: absolute; content: ""; height: 16px; width: 16px; left: 4px; bottom: 4px; background-color: white; transition: .4s; border-radius: 50%; }
  input:checked + .slider { background-color: var(--primary); }
  input:checked + .slider:before { transform: translateX(26px); }

  /* --- أنماط المهرجانات --- */
  .festival-card { 
    background: rgba(0,0,0,0.2); 
    border: 1px solid var(--border); 
    border-radius: 12px; 
    padding: 15px; 
    display: flex;
    flex-direction: column;
    margin-bottom: 15px; 
    transition: 0.2s; 
  }
  .festival-card:hover { background: rgba(255,255,255,0.05); border-color: var(--primary); }
  
  .deadline-badge { font-size: 0.75rem; padding: 4px 8px; border-radius: 4px; font-weight: bold; display: inline-flex; align-items: center; gap: 5px; }
  .deadline-urgent { background: rgba(239, 68, 68, 0.2); color: #EF4444; }
  .deadline-soon { background: rgba(245, 158, 11, 0.2); color: #F59E0B; }
  .deadline-ok { background: rgba(16, 185, 129, 0.2); color: #10B981; }

  /* ألوان الحالات */
  .status-To-Do { border-right: 4px solid #9CA3AF; }
  .status-Planning { border-right: 4px solid #FCD34D; }
  .status-Submitted { border-right: 4px solid #60A5FA; }
  .status-Pending { border-right: 4px solid #8B5CF6; }
  .status-Selected { border-right: 4px solid #22C55E; }
  .status-Rejected { border-right: 4px solid #EF4444; }

  /* نمط شريط الملخص الجديد */
  .summary-ribbon {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 15px;
    margin-bottom: 25px;
  }
  .ribbon-item {
    background: linear-gradient(135deg, rgba(255,255,255,0.05), rgba(0,0,0,0));
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 10px;
    padding: 15px;
    position: relative;
    overflow: hidden;
  }
  .ribbon-item::before {
    content: '';
    position: absolute;
    right: 0; top: 0; bottom: 0;
    width: 4px;
    background: var(--primary);
  }
  .ribbon-item h4 { margin: 0 0 5px 0; font-size: 0.8rem; color: #ccc; display: flex; alignItems: center; gap: 8px; }
  .ribbon-item .value { font-size: 1.4rem; font-weight: bold; color: white; }
  .ribbon-item .urgent-name { color: #FCA5A5; font-size: 0.85rem; margin-top: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: bold; }

  /* Sub-tabs */
  .sub-tabs { display: flex; gap: 10px; margin-bottom: 20px; border-bottom: 1px solid var(--border); padding-bottom: 10px; }
  .sub-tab { padding: 8px 16px; border-radius: 8px; cursor: pointer; font-weight: bold; color: #888; transition: 0.2s; }
  .sub-tab.active { background: var(--primary); color: white; }

  /* Table Styles for Subscribers */
  .data-table { width: 100%; border-collapse: collapse; margin-top: 15px; }
  .data-table th { text-align: right; padding: 12px; background: rgba(255,255,255,0.05); color: #9CA3AF; font-size: 0.9rem; border-bottom: 1px solid var(--border); }
  .data-table td { padding: 12px; border-bottom: 1px solid rgba(255,255,255,0.05); color: #eee; font-size: 0.95rem; }
  .data-table tr:hover { background: rgba(255,255,255,0.02); }

  /* Drag & Drop Styles (جديد) */
  .draggable-item { 
    background: #000; 
    border-radius: 12px; 
    overflow: hidden; 
    border: 1px solid var(--border); 
    transition: 0.3s;
    position: relative;
  }
  .draggable-item.dragging {
    opacity: 0.5;
    border-color: var(--primary);
    transform: scale(0.98);
  }
  .drag-handle {
    cursor: grab;
    padding: 10px;
    color: #555;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .drag-handle:hover { color: var(--primary); }

  /* Visibility Toggle (جديد) */
  .visibility-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0,0,0,0.6);
    padding: 5px;
    border-radius: 50%;
    cursor: pointer;
    z-index: 10;
    transition: 0.2s;
  }
  .visibility-btn:hover { background: var(--primary); color: white; }
  .item-hidden { filter: grayscale(1) opacity(0.6); }

  /* Fetch Button Style (جديد) */
  .fetch-btn {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: var(--primary);
    color: white;
    border: none;
    border-radius: 6px;
    padding: 5px 10px;
    font-size: 0.75rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: 0.2s;
  }
  .fetch-btn:hover { filter: brightness(1.1); }
`;

// مكون زر الترجمة الذكية
const AiTranslateBtn = ({ onTranslate, loading }) => (
  <button 
    type="button"
    className="btn-ai" 
    onClick={onTranslate} 
    disabled={loading}
    title="ترجمة تلقائية باستخدام الذكاء الاصطناعي"
  >
    {loading ? <Loader size={12} className="animate-spin" /> : <Sparkles size={12} />}
    {loading ? 'يترجم...' : 'ترجمة تلقائية'}
  </button>
);

// مكون حقل الترجمة العام
const TransField = ({ label, fieldKey, data, onChange, multiline = false, isObject = false, onAutoTranslate }) => {
  const languages = ['ar', 'en', 'fr', 'de', 'es'];
  const getValue = (lang) => {
    if (isObject) return data[lang] || '';
    return data.content_json?.[lang]?.[fieldKey] || '';
  };

  const [translating, setTranslating] = useState(false);

  const handleTranslateClick = async () => {
    // نأخذ النص العربي كمصدر
    const sourceText = isObject ? data['ar'] : data.content_json?.['ar']?.[fieldKey];
    if (!sourceText) return alert("يرجى كتابة النص العربي أولاً للترجمة منه.");
    
    setTranslating(true);
    try {
      if (onAutoTranslate) {
        await onAutoTranslate(sourceText, fieldKey);
      }
    } catch (e) {
      alert("حدث خطأ أثناء الترجمة. تأكد من إعداد مفتاح API.");
    }
    setTranslating(false);
  };

  return (
    <div style={{ marginBottom: '25px', paddingBottom: '15px', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: '8px'}}>
        <label className="label" style={{ color: '#F97316', fontSize: '1rem', margin:0 }}>{label}</label>
        {/* زر الترجمة يظهر فقط إذا مررنا دالة المعالجة */}
        {onAutoTranslate && <AiTranslateBtn onTranslate={handleTranslateClick} loading={translating} />}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px', marginTop: '10px' }}>
        {languages.map(lang => (
          <div key={lang} style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', top: '-8px', right: '10px', background: '#0F172A', padding: '0 5px', fontSize: '0.7rem', color: '#888' }}>{lang.toUpperCase()}</span>
            {multiline ? (
              <textarea className="input" rows="2" dir={lang === 'ar' ? 'rtl' : 'ltr'} value={getValue(lang)} onChange={(e) => onChange(lang, fieldKey, e.target.value)} />
            ) : (
              <input className="input" dir={lang === 'ar' ? 'rtl' : 'ltr'} value={getValue(lang)} onChange={(e) => onChange(lang, fieldKey, e.target.value)} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// مكون الأكورديون
const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px', background: 'rgba(255,255,255,0.03)', borderRadius: '8px', cursor: 'pointer', border: '1px solid rgba(255,255,255,0.08)' }} onClick={() => setIsOpen(!isOpen)}>
        <span style={{ fontWeight: 'bold' }}>{title}</span>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>
      {isOpen && <div style={{ padding: '20px', background: 'rgba(0,0,0,0.2)', borderRadius: '8px', marginBottom: '15px' }}>{children}</div>}
    </div>
  );
};

export default function Admin() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [activeSubTab, setActiveSubTab] = useState('warehouse'); // 'warehouse' | 'submissions'
  const [refreshing, setRefreshing] = useState(false);

  // --- Drag & Drop State ---
  const dragItem = useRef();
  const dragOverItem = useRef();

  // --- البيانات العامة ---
  const [data, setData] = useState({
    primary_color: '#F97316', bg_color: '#0B0F19',
    header_bg_color: 'rgba(11, 15, 25, 0.9)', footer_bg_color: '#000000',
    logo_url: '', hero_background_url: '', about_image_url: '', press_kit_url: '',
    seo_title: 'AMALCO', seo_description: '', copyright_text: '', favicon_url: '',
    contact_email: '', contact_phone: '', contact_address: '',
    social_facebook: '', social_instagram: '', social_twitter: '', social_youtube: '', social_tiktok: '', social_linkedin: '',
    content_json: { ar: {}, en: {}, fr: {}, de: {}, es: {} },
    sections_config: [], 
    quick_links_json: [],
    partners_json: [], // --- Partners & Awards Array
    default_theme: 'dark',
    intro_visible: true,
    intro_logo_url: '',
    intro_text: 'Welcome to Amalco',
    intro_duration: 3500,
    default_language: 'ar', // --- اللغة الافتراضية
    gemini_api_key: '' // --- مفتاح API للذكاء الاصطناعي
  });
  
  const [videos, setVideos] = useState([]);
  const [news, setNews] = useState([]);
  const [messages, setMessages] = useState([]);
  const [subscribers, setSubscribers] = useState([]); // --- NEW: Subscribers List
  const [stats, setStats] = useState({ visits: 0, videos: { count: 0, views: 0 }, news: { count: 0, views: 0 } });
  
  // --- حالة إضافة شريك جديد (New Partner State) ---
  const [newPartner, setNewPartner] = useState({ name: '', logo_url: '' });

  // --- بيانات وحالة المهرجانات ---
  const [festivals, setFestivals] = useState([]);
  const [editingFestivalId, setEditingFestivalId] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  const [newFestival, setNewFestival] = useState({
    festival_name: '',
    country: '', 
    video_id: '',
    deadline_date: '',
    festival_date: '',
    registration_start_date: '', 
    cost: '',
    currency: 'USD',
    platform_url: '',
    category: 'International',
    status: 'To Do' 
  });

  // --- حالات الإضافة للفيديو (محدث لدعم تعدد اللغات) ---
  const [newVideo, setNewVideo] = useState({ 
    titles: { ar: '', en: '', fr: '', de: '', es: '' }, 
    descriptions: { ar: '', en: '', fr: '', de: '', es: '' }, // --- جديد: وصف متعدد اللغات
    directors: { ar: '', en: '', fr: '', de: '', es: '' },    // --- جديد: مخرج متعدد اللغات
    genres: { ar: '', en: '', fr: '', de: '', es: '' },       // --- تصحيح: تغيير genre إلى genres كائن للغات
    video_url: '', 
    thumbnail_url: '',
    year: '',        
    poster_url: '',
    visible: true // --- جديد: حالة الظهور
  });
  
  const [newNews, setNewNews] = useState({ 
    titles: { ar: '', en: '', fr: '', de: '', es: '' }, 
    contents: { ar: '', en: '', fr: '', de: '', es: '' }, 
    image_url: '', 
    author: 'Amalco Team', 
    category: 'General' 
  });
  
  const [passData, setPassData] = useState({ old: '', new: '', confirm: '' });
  
  const [newSection, setNewSection] = useState({ 
    titles: { ar: '', en: '', fr: '', de: '', es: '' }, 
    type: 'text_image', 
    contents: { ar: '', en: '', fr: '', de: '', es: '' }, 
    image_url: '', 
    video_url: '' 
  });

  const DEFAULT_SECTIONS = [
    { id: 'hero', type: 'core', visible: true, title: 'الواجهة الرئيسية (Hero)' },
    { id: 'portfolio', type: 'core', visible: true, title: 'معرض الأعمال (Portfolio)' },
    { id: 'about', type: 'core', visible: true, title: 'من نحن (About)' },
    { id: 'news', type: 'core', visible: true, title: 'الأخبار (News)' },
    { id: 'contact', type: 'core', visible: true, title: 'تواصل معنا (Contact)' }
  ];

  // --- التحقق من تسجيل الدخول عند التحميل ---
  useEffect(() => {
    if (sessionStorage.getItem('amalco_admin_logged') === 'true') {
      setIsAuthenticated(true);
      fetchAllData();
    }
  }, []);

  // --- دالة جلب كل البيانات من السيرفر ---
  const fetchAllData = async () => {
    setRefreshing(true);
    try {
      const [s, v, n, m, st, f, sub] = await Promise.all([
        fetch('/.netlify/functions/getSettings').then(r => r.json()),
        fetch('/.netlify/functions/getVideos').then(r => r.json()),
        fetch('/.netlify/functions/getNews').then(r => r.json()),
        fetch('/.netlify/functions/getMessages').then(r => r.json()),
        fetch('/.netlify/functions/getAnalytics').then(r => r.json()),
        fetch('/.netlify/functions/getFestivalData').then(r => r.json()),
        fetch('/.netlify/functions/newsletter').then(r => r.json()) // --- Fetch Subscribers
      ]);

      const parse = (val, def) => {
        if (typeof val === 'string') {
          try { return JSON.parse(val); } catch(e) { return def; }
        }
        return val || def;
      };

      let loadedSections = parse(s.sections_config, null);
      if (!Array.isArray(loadedSections)) {
        loadedSections = DEFAULT_SECTIONS;
      }

      const defaultContent = { ar: {}, en: {}, fr: {}, de: {}, es: {} };
      const loadedContent = parse(s.content_json, {});

      setData({ 
        ...s, 
        content_json: { ...defaultContent, ...loadedContent },
        sections_config: loadedSections,
        quick_links_json: parse(s.quick_links_json, []),
        partners_json: parse(s.partners_json, []), // تحميل الشركاء
        default_theme: s.default_theme || 'dark',
        intro_visible: s.intro_visible !== undefined ? s.intro_visible : true,
        intro_duration: s.intro_duration || 3500,
        intro_text: s.intro_text || 'Welcome to Amalco',
        intro_logo_url: s.intro_logo_url || '',
        default_language: s.default_language || 'ar', // --- جلب اللغة الافتراضية
        gemini_api_key: s.gemini_api_key || '' // --- جلب مفتاح API
      });
      setVideos(v || []);
      setNews(n || []);
      setMessages(m || []);
      setStats({
        visits: st?.visits || 0,
        videos: st?.videos || { count: 0, views: 0 },
        news: st?.news || { count: 0, views: 0 }
      });
      setFestivals(Array.isArray(f) ? f : []);
      setSubscribers(Array.isArray(sub) ? sub : []); // --- Set Subscribers

    } catch (e) { console.error("Fetch Error", e); }
    setRefreshing(false);
  };

  // --- دوال الحفظ والتعديل العامة ---
  const handleSaveSettings = async () => {
    setLoading(true);
    try {
      const res = await fetch('/.netlify/functions/updateSettings', { method: 'POST', body: JSON.stringify(data) });
      const result = await res.json();
      if (res.ok) {
        alert("تم حفظ الإعدادات بنجاح ✅");
      } else {
        throw new Error(result.error || "خطأ في الحفظ");
      }
    } catch (err) {
      alert("فشل الحفظ: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // --- دالة الترجمة الذكية العامة (NEW) ---
  const executeTranslation = async (text, type = 'general') => {
    if (!data.gemini_api_key) {
      throw new Error("لم يتم إعداد مفتاح API. يرجى إضافته في تبويب اللغات أولاً.");
    }
    const res = await fetch('/.netlify/functions/translateContent', {
      method: 'POST',
      body: JSON.stringify({ text, type })
    });
    const result = await res.json();
    if (!res.ok) throw new Error(result.error || "فشل الاتصال بخدمة الترجمة");
    return result; // Returns { en: "...", fr: "...", ... }
  };

  const moveSection = (index, direction) => {
    const newSections = [...data.sections_config];
    if (direction === 'up' && index > 0) {
      [newSections[index], newSections[index - 1]] = [newSections[index - 1], newSections[index]];
    } else if (direction === 'down' && index < newSections.length - 1) {
      [newSections[index], newSections[index + 1]] = [newSections[index + 1], newSections[index]];
    }
    setData({ ...data, sections_config: newSections });
  };

  const toggleSection = (index) => {
    const newSections = [...data.sections_config];
    newSections[index].visible = !newSections[index].visible;
    setData({ ...data, sections_config: newSections });
  };

  const deleteCustomSection = (index) => {
    if (window.confirm("هل أنت متأكد من حذف هذا القسم؟")) {
      const newSections = data.sections_config.filter((_, i) => i !== index);
      setData({ ...data, sections_config: newSections });
    }
  };

  const addCustomSection = () => {
    if (!newSection.titles.ar) return alert("يرجى وضع عنوان للقسم بالعربية على الأقل");
    const sectionToAdd = {
      id: `custom_${Date.now()}`,
      type: 'custom',
      subType: newSection.type, 
      visible: true,
      titles: newSection.titles, 
      contents: newSection.contents, 
      image_url: newSection.image_url,
      video_url: newSection.video_url,
      title: newSection.titles.ar 
    };
    setData({ ...data, sections_config: [...data.sections_config, sectionToAdd] });
    setNewSection({ 
      titles: { ar: '', en: '', fr: '', de: '', es: '' }, 
      type: 'text_image', 
      contents: { ar: '', en: '', fr: '', de: '', es: '' }, 
      image_url: '', 
      video_url: '' 
    });
    alert("تم إضافة القسم! لا تنس الضغط على حفظ التغييرات.");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await fetch('/.netlify/functions/verifyPassword', { method: 'POST', body: JSON.stringify({ password: passwordInput }) });
    const result = await res.json();
    setLoading(false);
    if (result.success) {
      setIsAuthenticated(true);
      sessionStorage.setItem('amalco_admin_logged', 'true');
      fetchAllData();
    } else {
      alert("رمز المرور خاطئ");
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('amalco_admin_logged');
    setIsAuthenticated(false);
  };

  const handleMatrixChange = (lang, key, value) => {
    setData(prev => ({
      ...prev,
      content_json: { 
        ...prev.content_json, 
        [lang]: { 
          ...(prev.content_json[lang] || {}), 
          [key]: value 
        } 
      }
    }));
  };

  // --- دوال المعالجة للترجمة التلقائية ---
  const handleGeneralAutoTranslate = async (text, fieldKey) => {
    const translations = await executeTranslation(text, 'website_interface');
    ['en', 'fr', 'de', 'es'].forEach(lang => {
      handleMatrixChange(lang, fieldKey, translations[lang]);
    });
  };

  const handleNewsTransChange = (lang, field, value) => {
    setNewNews(prev => ({
      ...prev,
      [field === 'title' ? 'titles' : 'contents']: { ...prev[field === 'title' ? 'titles' : 'contents'], [lang]: value }
    }));
  };

  const handleNewsAutoTranslate = async (text, fieldKey) => { 
    const translations = await executeTranslation(text, fieldKey === 'title' ? 'news_title' : 'news_content');
    setNewNews(prev => {
      const targetObj = fieldKey === 'title' ? 'titles' : 'contents';
      return {
        ...prev,
        [targetObj]: { ...prev[targetObj], ...translations }
      };
    });
  };

  const handleSectionTransChange = (lang, field, value) => {
    setNewSection(prev => ({
      ...prev,
      [field === 'title' ? 'titles' : 'contents']: { ...prev[field === 'title' ? 'titles' : 'contents'], [lang]: value }
    }));
  };

  const handleSectionAutoTranslate = async (text, fieldKey) => {
    const translations = await executeTranslation(text, 'section_content');
    setNewSection(prev => {
      const targetObj = fieldKey === 'title' ? 'titles' : 'contents';
      return {
        ...prev,
        [targetObj]: { ...prev[targetObj], ...translations }
      };
    });
  };

  // --- دوال معالجة الفيديو الجديدة (تحديث) ---
  const handleVideoTransChange = (lang, field, value) => {
    setNewVideo(prev => ({
      ...prev,
      titles: { ...prev.titles, [lang]: value }
    }));
  };

  const handleVideoDirectorChange = (lang, _, value) => {
    setNewVideo(prev => ({ ...prev, directors: { ...prev.directors, [lang]: value } }));
  };

  const handleVideoDescriptionChange = (lang, _, value) => {
    setNewVideo(prev => ({ ...prev, descriptions: { ...prev.descriptions, [lang]: value } }));
  };

  // --- دوال الترجمة التلقائية للفيديو (تحديث) ---
  const handleVideoAutoTranslate = async (text, fieldKey) => {
    const translations = await executeTranslation(text, 'movie_title');
    setNewVideo(prev => ({ ...prev, titles: { ...prev.titles, ...translations } }));
  };

  const handleVideoDirectorAutoTranslate = async (text) => {
    const translations = await executeTranslation(text, 'director_name');
    setNewVideo(prev => ({ ...prev, directors: { ...prev.directors, ...translations } }));
  };

  const handleVideoDescriptionAutoTranslate = async (text) => {
    const translations = await executeTranslation(text, 'movie_synopsis');
    setNewVideo(prev => ({ ...prev, descriptions: { ...prev.descriptions, ...translations } }));
  };

  // --- ميزات الفيديو الجديدة (الجلب والتكرار والسحب) ---
  
  // 1. الجلب التلقائي (Magic Fetch)
  const fetchMetadata = async () => {
    if (!newVideo.video_url) return alert("يرجى إدخال الرابط أولاً");
    // --- حماية: إذا كان الرابط يبدو ككود HTML (تضمين)، لا نحاول جلبه ---
    if (newVideo.video_url.trim().startsWith('<')) {
        return alert("ميزة الجلب التلقائي لا تعمل مع أكواد التضمين (Embed Code). يرجى ملء البيانات يدوياً.");
    }

    setLoading(true);
    try {
      let fetchUrl = '';
      if (newVideo.video_url.includes('youtube') || newVideo.video_url.includes('youtu.be')) {
        fetchUrl = `https://noembed.com/embed?url=${newVideo.video_url}`;
      } else if (newVideo.video_url.includes('vimeo')) {
        fetchUrl = `https://vimeo.com/api/oembed.json?url=${newVideo.video_url}`;
      } else {
        throw new Error("الرابط غير مدعوم حالياً (يدعم يوتيوب وفيميو)");
      }

      const res = await fetch(fetchUrl);
      const meta = await res.json();
      
      if (meta.title) {
        setNewVideo(prev => ({
          ...prev,
          titles: { ...prev.titles, ar: meta.title }, 
          thumbnail_url: meta.thumbnail_url || '',
          // محاولة تخمين المخرج من اسم القناة إذا أمكن، وإلا نتركه
          directors: { ...prev.directors, ar: meta.author_name || '' } 
        }));
        alert("تم جلب البيانات بنجاح! 🪄");
      }
    } catch (e) {
      alert("فشل الجلب: " + e.message);
    } finally {
      setLoading(false);
    }
  };

  // 2. التكرار (Duplicate)
  const duplicateVideo = (video) => {
    try {
      setNewVideo({
        ...newVideo,
        titles: JSON.parse(video.title || '{}'),
        descriptions: JSON.parse(video.description || '{}'),
        directors: JSON.parse(video.director || '{}'),
        genres: JSON.parse(video.genre || '{}'), // --- تصحيح: تحويل النص JSON إلى كائن genres
        year: video.year,
        video_url: '', // نفرغ الرابط ليدخل الجديد
        thumbnail_url: video.thumbnail_url,
        poster_url: video.poster_url,
        visible: true
      });
      window.scrollTo(0, 500); // تمرير للفورم
      alert("تم نسخ البيانات للفورم، قم بتعديل الرابط واحفظ ✅");
    } catch (e) {
      console.error(e);
      alert("خطأ في نسخ البيانات");
    }
  };

  // 3. التبديل المرئي (Visibility Toggle) - محاكاة (يحتاج دعم Backend كامل)
  const toggleVisibility = async (id, currentStatus) => {
    // تحديث محلي سريع
    const updatedVideos = videos.map(v => v.id === id ? { ...v, visible: !currentStatus } : v);
    setVideos(updatedVideos);
    // هنا يجب إرسال التحديث للسيرفر (updateVideo)
    // بما أننا لم نضف حقل visible لقاعدة البيانات بعد، سنتركه كتحديث واجهة فقط حالياً
  };

  // 4. السحب والإفلات (Drag & Drop)
  const onDragStart = (e, index) => {
    dragItem.current = index;
    e.target.classList.add('dragging');
  };

  const onDragEnter = (e, index) => {
    dragOverItem.current = index;
    e.preventDefault();
  };

  const onDragEnd = async (e) => {
    e.target.classList.remove('dragging');
    const _videos = [...videos];
    const draggedItemContent = _videos[dragItem.current];
    _videos.splice(dragItem.current, 1);
    _videos.splice(dragOverItem.current, 0, draggedItemContent);
    
    dragItem.current = null;
    dragOverItem.current = null;
    setVideos(_videos);

    // حفظ الترتيب الجديد
    try {
      await fetch('/.netlify/functions/updateVideoOrder', {
        method: 'POST',
        body: JSON.stringify({ videos: _videos })
      });
    } catch (err) {
      console.error("فشل حفظ الترتيب", err);
    }
  };

  const addPartner = () => {
    if (!newPartner.logo_url) return alert("يرجى إدخال رابط الشعار");
    const updatedPartners = [...(data.partners_json || []), { id: Date.now(), ...newPartner }];
    setData({ ...data, partners_json: updatedPartners });
    setNewPartner({ name: '', logo_url: '' });
  };

  const removePartner = (id) => {
    const updatedPartners = data.partners_json.filter(p => p.id !== id);
    setData({ ...data, partners_json: updatedPartners });
  };

  // --- إدارة الفيديوهات (محدث لتجهيز البيانات كـ JSON) ---
  const addVideo = async (e) => { 
    e.preventDefault(); 
    if(!newVideo.titles.ar) return alert("يرجى إدخال عنوان العمل بالعربية");

    setLoading(true); // تفعيل مؤشر التحميل لمنع الضغط المتكرر

    try {
        // نجهز البيانات للإرسال، نحول الكائنات لنصوص JSON
        const payload = {
            ...newVideo,
            title: JSON.stringify(newVideo.titles),
            director: JSON.stringify(newVideo.directors),       
            description: JSON.stringify(newVideo.descriptions), 
            genre: JSON.stringify(newVideo.genres)              
        };

        const response = await fetch('/.netlify/functions/addVideo', { 
            method: 'POST', 
            body: JSON.stringify(payload) 
        }); 
        
        // التحقق مما إذا كان السيرفر قد قبل الطلب أم لا
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || "حدث خطأ غير معروف في السيرفر");
        }

        // إذا وصلنا هنا، يعني أن الإضافة تمت بنجاح
        alert("تم إضافة العمل بنجاح ✅");

        // إعادة تعيين الحقول
        setNewVideo({ 
          titles: { ar: '', en: '', fr: '', de: '', es: '' }, 
          descriptions: { ar: '', en: '', fr: '', de: '', es: '' }, // تأكدنا من إعادة تعيين الوصف
          directors: { ar: '', en: '', fr: '', de: '', es: '' },    // تأكدنا من إعادة تعيين المخرج
          genres: { ar: '', en: '', fr: '', de: '', es: '' },       // تأكدنا من إعادة تعيين التصنيف
          video_url: '', 
          thumbnail_url: '',
          year: '',        
          poster_url: '',
          visible: true 
        }); 
        
        // تحديث القائمة فوراً
        await fetchAllData(); 

    } catch (err) {
        console.error("خطأ في إضافة الفيديو:", err);
        alert("❌ فشلت الإضافة: " + err.message);
    } finally {
        setLoading(false); // إيقاف مؤشر التحميل في جميع الحالات
    }
  };

  const deleteVideo = async (id) => { if(window.confirm("حذف الفيديو؟")) { await fetch('/.netlify/functions/deleteVideo', { method: 'POST', body: JSON.stringify({id}) }); fetchAllData(); } };
  
  // دالة نسخ الرابط المباشر
  const copyDirectLink = (type, id) => {
    const baseUrl = window.location.origin;
    const param = type === 'video' ? 'v' : 'n';
    const fullUrl = `${baseUrl}/?${param}=${id}`;
    navigator.clipboard.writeText(fullUrl);
    alert("تم نسخ رابط المشاركة المباشر ✅");
  };

  const addNews = async (e) => { 
    e.preventDefault(); 
    if(!newNews.titles.ar) return alert("يرجى إدخال عنوان الخبر بالعربية");
    
    const payload = {
      ...newNews,
      title: JSON.stringify(newNews.titles),
      content: JSON.stringify(newNews.contents)
    };

    await fetch('/.netlify/functions/addNews', { method: 'POST', body: JSON.stringify(payload) }); 
    
    setNewNews({ 
      titles: { ar: '', en: '', fr: '', de: '', es: '' }, 
      contents: { ar: '', en: '', fr: '', de: '', es: '' }, 
      image_url: '', 
      author: 'Amalco Team', 
      category: 'General' 
    }); 
    fetchAllData(); 
  };

  const deleteNews = async (id) => { if(window.confirm("حذف الخبر؟")) { await fetch('/.netlify/functions/deleteNews', { method: 'POST', body: JSON.stringify({id}) }); fetchAllData(); } };

  // --- إدارة الرسائل ---
  const deleteMessage = async (id) => { if(window.confirm("حذف الرسالة؟")) { await fetch('/.netlify/functions/deleteMessage', { method: 'POST', body: JSON.stringify({id}) }); fetchAllData(); } };

  // --- إدارة المهرجانات ---
  const addFestival = async (e) => {
    e.preventDefault();
    if (!newFestival.festival_name) return alert("اسم المهرجان مطلوب");
    
    try {
      const res = await fetch('/.netlify/functions/addFestival', { 
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newFestival) 
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || "خطأ غير معروف في السيرفر");
      }

      alert("تمت الإضافة بنجاح ✅");
      
      setNewFestival({
        festival_name: '', country: '', video_id: '', deadline_date: '', festival_date: '', registration_start_date: '', cost: '', currency: 'USD', platform_url: '', category: 'International', status: 'To Do'
      });
      // العودة للمخزن عند الإضافة الافتراضية
      setActiveSubTab('warehouse');
      fetchAllData();
    } catch (err) {
      alert("❌ فشلت العملية: " + err.message);
    }
  };

  const deleteFestival = async (id) => {
    if (window.confirm("هل تريد حذف هذا العنصر؟")) {
      try {
        await fetch('/.netlify/functions/deleteFestival', { method: 'POST', body: JSON.stringify({ id }) });
        fetchAllData();
      } catch (err) {
        alert("خطأ في الحذف");
      }
    }
  };

  const startEditingFestival = (fest) => {
    setEditingFestivalId(fest.id);
    setEditFormData({ ...fest });
  };

  // نقل من المخزن إلى المشاركات
  const moveToSubmission = (fest) => {
    // نفتح نافذة إضافة لكن ببيانات المهرجان
    setActiveSubTab('submissions');
    setNewFestival({
        ...newFestival,
        festival_name: fest.festival_name,
        country: fest.country,
        deadline_date: fest.deadline_date ? fest.deadline_date.split('T')[0] : '',
        registration_start_date: fest.registration_start_date ? fest.registration_start_date.split('T')[0] : '',
        cost: fest.cost,
        platform_url: fest.platform_url,
        video_id: '', // نتركه فارغ ليختاره المستخدم
        status: 'Planning'
    });
    // Scroll to form (optional)
    window.scrollTo(0, 500);
  };

  const handleFestivalStatusChange = async (id, newStatus) => {
    const updatedFestivals = festivals.map(f => f.id === id ? { ...f, status: newStatus } : f);
    setFestivals(updatedFestivals);
    await fetch('/.netlify/functions/updateFestival', { method: 'POST', body: JSON.stringify({ id, status: newStatus }) });
  };

  const saveFestivalChanges = async () => {
    try {
      const res = await fetch('/.netlify/functions/updateFestival', { 
        method: 'POST', 
        body: JSON.stringify(editFormData) 
      });
      
      if (!res.ok) throw new Error("Server Error");
      
      setEditingFestivalId(null);
      fetchAllData();
      alert("تم التحديث بنجاح ✅");
    } catch (err) {
      alert("خطأ في الحفظ");
    }
  };

  // --- NEW: Subscribers Handlers ---
  const deleteSubscriber = async (id) => {
    if(window.confirm("هل تريد حذف هذا المشترك؟")) {
      try {
        await fetch('/.netlify/functions/newsletter', { method: 'DELETE', body: JSON.stringify({ id }) });
        fetchAllData();
      } catch (e) { alert("خطأ في الحذف"); }
    }
  };

  const downloadSubscribersCSV = () => {
    if (subscribers.length === 0) return alert("لا يوجد مشتركين لتصديرهم");
    
    // Create CSV content
    const csvContent = "data:text/csv;charset=utf-8," 
      + "ID,Email,Date\n"
      + subscribers.map(s => `${s.id},${s.email},${new Date(s.created_at).toLocaleDateString()}`).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "amalco_subscribers.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // --- تغيير كلمة المرور ---
  const changePassword = async (e) => { 
    e.preventDefault(); 
    if(passData.new !== passData.confirm) return alert("كلمات المرور الجديدة غير متطابقة");
    setLoading(true);
    try {
        const res = await fetch('/.netlify/functions/changePassword', { 
            method: 'POST', 
            body: JSON.stringify({ oldPassword: passData.old, newPassword: passData.new }) 
        });
        const result = await res.json();
        if(res.ok) { 
            alert("تم تغيير كلمة المرور بنجاح ✅"); 
            setPassData({old:'', new:'', confirm:''}); 
        } else { 
            alert(result.error || "فشل تغيير كلمة المرور"); 
        }
    } catch (error) { alert("خطأ في الاتصال بالسيرفر"); } 
    finally { setLoading(false); }
  };

  // --- التحليلات والترتيب ---
  const topVideos = [...videos].sort((a, b) => (b.views || 0) - (a.views || 0)).slice(0, 4);
  const chartData = [ Math.floor(stats.visits * 0.12), Math.floor(stats.visits * 0.15), Math.floor(stats.visits * 0.11), Math.floor(stats.visits * 0.20), Math.floor(stats.visits * 0.14), Math.floor(stats.visits * 0.18), Math.floor(stats.visits * 0.10) ];
  const maxVal = Math.max(...chartData, 1);

  const getLocalizedTitle = (jsonString) => {
    try {
      const titles = JSON.parse(jsonString);
      return titles.ar || "بدون عنوان";
    } catch (e) {
      return jsonString; 
    }
  };

  // Helper to handle annual recurrence (ignore year, find next occurrence)
  // هذه الدالة تتجاهل سنة الموعد وتحدد "تاريخ الموعد القادم" بناءً على اليوم والشهر
  const getEffectiveDeadline = (dateString) => {
    if (!dateString) return null;
    const deadlineOriginal = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize today

    // Create target date for CURRENT year
    let targetDate = new Date(today.getFullYear(), deadlineOriginal.getMonth(), deadlineOriginal.getDate());
    
    // If target is in the past (e.g. deadline March 15, today April 1), move target to NEXT year
    if (targetDate < today) {
      targetDate.setFullYear(today.getFullYear() + 1);
    }
    return targetDate;
  };

  // حساب الأيام المتبقية
  const calculateDaysRemaining = (deadlineStr) => {
    if(!deadlineStr) return 0;
    const today = new Date();
    today.setHours(0,0,0,0);
    const target = getEffectiveDeadline(deadlineStr);
    const diffTime = target - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  // فصل المهرجانات إلى مخزن ومشاركات
  const warehouseFestivals = festivals.filter(f => !f.video_id);
  const activeSubmissions = festivals.filter(f => f.video_id);

  // ترتيب حسب الموعد القادم الأقرب (سنوياً)
  const sortFestivals = (list) => {
      return [...list].sort((a, b) => {
         const dateA = getEffectiveDeadline(a.deadline_date) || new Date(9999,0,1);
         const dateB = getEffectiveDeadline(b.deadline_date) || new Date(9999,0,1);
         return dateA - dateB;
      });
  };

  const getStatusLabel = (status) => {
    const labels = {
      'To Do': { text: 'مهمة جديدة', color: '#9CA3AF' },
      'Planning': { text: 'قيد التجهيز', color: '#FCD34D' },
      'Submitted': { text: 'تم الإرسال', color: '#60A5FA' },
      'Pending': { text: 'بانتظار الرد', color: '#8B5CF6' },
      'Selected': { text: 'تم القبول 🏆', color: '#22C55E' },
      'Rejected': { text: 'مرفوض', color: '#EF4444' }
    };
    return labels[status] || { text: status, color: '#fff' };
  };

  // --- حساب إحصائيات الشريط العلوي (Top Ribbon Data) ---
  const urgentDeadline = [...festivals]
    .filter(f => (f.status === 'To Do' || f.status === 'Planning'))
    .sort((a, b) => {
       const dateA = getEffectiveDeadline(a.deadline_date) || new Date(9999,0,1);
       const dateB = getEffectiveDeadline(b.deadline_date) || new Date(9999,0,1);
       return dateA - dateB;
    })[0];

  const pendingCount = activeSubmissions.filter(f => f.status === 'Submitted' || f.status === 'Pending').length;
  const acceptedCount = activeSubmissions.filter(f => f.status === 'Selected').length;
  const rejectedCount = activeSubmissions.filter(f => f.status === 'Rejected').length; 
  const planningCount = activeSubmissions.filter(f => f.status === 'Planning').length; 
  
  // Budget (Only active submissions)
  const plannedBudget = activeSubmissions.reduce((sum, f) => sum + (parseFloat(f.cost) || 0), 0);

  // --- واجهة تسجيل الدخول ---
  if (!isAuthenticated) return (
    <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', background: '#0B0F19', direction: 'rtl' }}>
      <style>{adminStyles}</style>
      <div className="card" style={{ width: 400, textAlign: 'center' }}>
        <Shield size={60} color="var(--primary)" style={{margin:'0 auto 20px'}} />
        <h2 style={{ marginBottom: 30 }}>بوابة إدارة AMALCO</h2>
        <form onSubmit={handleLogin}>
          <input type="password" placeholder="أدخل رمز الدخول" className="input" style={{ textAlign: 'center', marginBottom: 20 }} value={passwordInput} onChange={e => setPasswordInput(e.target.value)} autoFocus />
          <button className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>{loading ? 'تحقق...' : 'دخول'}</button>
        </form>
      </div>
    </div>
  );

  // --- الواجهة الرئيسية ---
  return (
    <div className="admin-layout" dir="rtl">
      <style>{adminStyles}</style>
      <div className="sidebar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 40, padding: '0 10px' }}>
          <Monitor size={30} color="var(--primary)" />
          <h2 className="brand-text" style={{ fontSize: '1.4rem', fontWeight: 800 }}>AMALCO<span style={{ color: 'var(--primary)' }}>.</span></h2>
        </div>
        
        <div className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`} onClick={() => setActiveTab('dashboard')}><LayoutDashboard size={20}/> <span>لوحة القيادة</span></div>
        <div className={`nav-item ${activeTab === 'festivals' ? 'active' : ''}`} onClick={() => setActiveTab('festivals')}><Calendar size={20}/> <span>إدارة المهرجانات</span></div>
        <div className={`nav-item ${activeTab === 'sections' ? 'active' : ''}`} onClick={() => setActiveTab('sections')}><LayoutTemplate size={20}/> <span>ترتيب الأقسام</span></div>
        <div className={`nav-item ${activeTab === 'content' ? 'active' : ''}`} onClick={() => setActiveTab('content')}><Globe size={20}/> <span>اللغات والمحتوى</span></div>
        <div className={`nav-item ${activeTab === 'branding' ? 'active' : ''}`} onClick={() => setActiveTab('branding')}><Palette size={20}/> <span>الهوية والتصميم</span></div>
        <div className={`nav-item ${activeTab === 'media' ? 'active' : ''}`} onClick={() => setActiveTab('media')}><Video size={20}/> <span>إدارة الأعمال</span></div>
        <div className={`nav-item ${activeTab === 'news' ? 'active' : ''}`} onClick={() => setActiveTab('news')}><Newspaper size={20}/> <span>الأخبار</span></div>
        {/* --- NEW: Partners Sidebar Item --- */}
        <div className={`nav-item ${activeTab === 'partners' ? 'active' : ''}`} onClick={() => setActiveTab('partners')}><Award size={20}/> <span>شركاء النجاح</span></div>
        
        {/* --- NEW: Subscribers Sidebar Item --- */}
        <div className={`nav-item ${activeTab === 'newsletter' ? 'active' : ''}`} onClick={() => setActiveTab('newsletter')}>
          <Users2 size={20}/> <span>القائمة البريدية</span>
          {subscribers.length > 0 && <span style={{background:'var(--primary)', padding:'2px 6px', borderRadius:'10px', fontSize:'0.7rem', color:'white'}}>{subscribers.length}</span>}
        </div>
        {/* ------------------------------------ */}

        <div className={`nav-item ${activeTab === 'inbox' ? 'active' : ''}`} onClick={() => setActiveTab('inbox')}><MessageSquare size={20}/> <span>البريد</span> {messages.length > 0 && <span style={{background:'red', padding:'2px 6px', borderRadius:'10px', fontSize:'0.7rem'}}>{messages.length}</span>}</div>
        <div className={`nav-item ${activeTab === 'security' ? 'active' : ''}`} onClick={() => setActiveTab('security')}><Lock size={20}/> <span>الأمان</span></div>

        <div style={{ marginTop: 'auto' }}>
          <button className="btn btn-primary" style={{ width: '100%', marginBottom: 10 }} onClick={handleSaveSettings} disabled={loading}>{loading ? 'جاري الحفظ...' : 'حفظ التغييرات'}</button>
          <button className="btn btn-danger" style={{ width: '100%', justifyContent: 'center' }} onClick={handleLogout}><LogOut size={18}/> خروج</button>
        </div>
      </div>

      <div className="main-content">
        
        {/* --- Dashboard --- */}
        {activeTab === 'dashboard' && (
          <div className="animate-fade-in">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
              <div><h1>لوحة القيادة والتحليل</h1><p style={{color:'var(--text-muted)'}}>نظرة شاملة على أداء منصة AMALCO.</p></div>
              <button className="btn btn-secondary" onClick={fetchAllData}><RefreshCw size={18} className={refreshing ? 'animate-spin' : ''}/></button>
            </div>

            <div className="stats-grid">
              <div className="stat-card">
                <div style={{background:'rgba(249, 115, 22, 0.1)', padding:15, borderRadius:12}}><Users size={32} color="var(--primary)" /></div>
                <div style={{flex:1}}><p style={{ margin: 0, fontSize: '0.9rem', color: '#9CA3AF' }}>إجمالي الزيارات</p><h2 style={{ margin: '5px 0', fontSize: '2.2rem' }}>{stats?.visits || 0}</h2></div>
              </div>
              <div className="stat-card">
                <div style={{background:'rgba(59, 130, 246, 0.1)', padding:15, borderRadius:12}}><Eye size={32} color="#3B82F6" /></div>
                <div style={{flex:1}}><p style={{ margin: 0, fontSize: '0.9rem', color: '#9CA3AF' }}>مشاهدات الأعمال</p><h2 style={{ margin: '5px 0', fontSize: '2.2rem' }}>{stats?.videos?.views || 0}</h2></div>
              </div>
              <div className="stat-card">
                <div style={{background:'rgba(34, 197, 94, 0.1)', padding:15, borderRadius:12}}><FileText size={32} color="#22C55E" /></div>
                <div style={{flex:1}}><p style={{ margin: 0, fontSize: '0.9rem', color: '#9CA3AF' }}>تفاعل الأخبار</p><h2 style={{ margin: '5px 0', fontSize: '2.2rem' }}>{stats?.news?.views || 0}</h2></div>
              </div>
            </div>

            <div style={{display:'grid', gridTemplateColumns:'2fr 1fr', gap:25}}>
              <div className="card">
                <div style={{display:'flex', justifyContent:'space-between', marginBottom:20}}><h3>توزيع نشاط الزوار</h3></div>
                <div className="chart-container">
                  {chartData.map((val, i) => (
                    <div key={i} className="chart-bar" style={{height: `${(val/maxVal) * 100}%`}} data-value={val}></div>
                  ))}
                </div>
              </div>
              <div className="card" style={{display:'flex', flexDirection:'column', justifyContent:'center'}}>
                <h3 style={{marginBottom:20, textAlign:'center'}}>أجهزة الدخول</h3>
                <div style={{display:'flex', justifyContent:'space-around'}}>
                    <div style={{textAlign:'center'}}><Monitor size={40} color="var(--primary)" /><div style={{marginTop:10, fontWeight:'bold'}}>Desktop</div></div>
                    <div style={{textAlign:'center'}}><Smartphone size={40} color="#9CA3AF" /><div style={{marginTop:10, fontWeight:'bold'}}>Mobile</div></div>
                </div>
              </div>
            </div>

            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:25, marginTop:25}}>
               <div className="card">
                  <h3 style={{marginBottom:20, display:'flex', alignItems:'center', gap:10}}><TrendingUp size={20} color="var(--primary)"/> الأعمال الأكثر مشاهدة</h3>
                  <div style={{display:'flex', flexDirection:'column', gap:12}}>
                    {topVideos.map((v, i) => (
                      <div key={v.id} style={{display:'flex', alignItems:'center', gap:15, background:'rgba(0,0,0,0.2)', padding:10, borderRadius:10}}>
                        <div style={{width:30, height:30, background:'var(--primary)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'bold'}}>{i+1}</div>
                        <div style={{flex:1}}><div style={{fontSize:'0.9rem', fontWeight:'bold'}}>{getLocalizedTitle(v.title)}</div></div>
                        <div style={{textAlign:'left'}}><div style={{fontWeight:'bold', color:'var(--primary)'}}>{v.views || 0}</div><div style={{fontSize:'0.6rem', color:'#555'}}>مشاهدة</div></div>
                      </div>
                    ))}
                  </div>
               </div>
               <div className="card">
                  <h3 style={{marginBottom:20, display:'flex', alignItems:'center', gap:10}}><Clock size={20} color="#3B82F6"/> آخر الرسائل</h3>
                  <div style={{display:'flex', flexDirection:'column', gap:12}}>
                    {messages.slice(0, 4).map(m => (
                      <div key={m.id} style={{padding:12, borderRight:'3px solid var(--primary)', background:'rgba(255,255,255,0.02)', borderRadius:'0 8px 8px 0'}}>
                        <div style={{display:'flex', justifyContent:'space-between'}}><span style={{fontWeight:'bold', fontSize:'0.9rem'}}>{m.sender_name}</span><span style={{fontSize:'0.7rem', color:'#555'}}>{new Date(m.created_at).toLocaleDateString()}</span></div>
                        <p style={{margin:0, fontSize:'0.8rem', color:'#999', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{m.message_content}</p>
                      </div>
                    ))}
                  </div>
               </div>
            </div>
          </div>
        )}

        {/* --- Festivals Tab (UPDATED WITH SUB-TABS) --- */}
        {activeTab === 'festivals' && (
          <div className="animate-fade-in">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div>
                <h1>إدارة المهرجانات الذكية</h1>
                <p style={{color:'var(--text-muted)'}}>مركز إدارة المشاركات والمواعيد.</p>
              </div>
              {/* --- قسم الميزانية الإجمالية (تم استرجاعه) --- */}
              <div style={{background: 'rgba(34, 197, 94, 0.1)', padding: '10px 20px', borderRadius: 12, border: '1px solid rgba(34, 197, 94, 0.2)'}}>
                <div style={{fontSize: '0.8rem', color: '#4ADE80'}}>الميزانية (الفعالة فقط)</div>
                <div style={{fontSize: '1.5rem', fontWeight: 'bold', color: '#fff'}}>
                    ${plannedBudget}
                </div>
              </div>
            </div>

            {/* الشريط العلوي (Top Ribbon) */}
            <div className="summary-ribbon">
              <div className="ribbon-item">
                <h4><AlertTriangle size={16} color="#FCA5A5"/> الموعد الأقرب</h4>
                {urgentDeadline ? (
                  <>
                    <div className="value">{calculateDaysRemaining(urgentDeadline.deadline_date)} يوم</div>
                    <div className="urgent-name">{urgentDeadline.festival_name}</div>
                  </>
                ) : <div className="value" style={{fontSize:'1rem'}}>لا توجد مهام</div>}
              </div>
              <div className="ribbon-item" style={{borderColor: 'rgba(139, 92, 246, 0.2)'}}>
                <h4 style={{color: '#A78BFA'}}><Send size={16}/> قيد الانتظار</h4>
                <div className="value">{pendingCount}</div>
                <div style={{fontSize:'0.7rem', color:'#888'}}>مهرجان</div>
              </div>
              <div className="ribbon-item" style={{borderColor: 'rgba(34, 197, 94, 0.2)'}}>
                <h4 style={{color: '#4ADE80'}}><Trophy size={16}/> القبولات</h4>
                <div className="value">{acceptedCount}</div>
                <div style={{fontSize:'0.7rem', color:'#888'}}>مهرجان</div>
              </div>
              <div className="ribbon-item" style={{borderColor: 'rgba(239, 68, 68, 0.2)'}}>
                <h4 style={{color: '#EF4444'}}><XCircle size={16}/> المرفوضة</h4>
                <div className="value">{rejectedCount}</div>
                <div style={{fontSize:'0.7rem', color:'#888'}}>مهرجان</div>
              </div>
              <div className="ribbon-item" style={{borderColor: 'rgba(245, 158, 11, 0.2)'}}>
                <h4 style={{color: '#FCD34D'}}><Briefcase size={16}/> قيد التجهيز</h4>
                <div className="value">{planningCount}</div>
                <div style={{fontSize:'0.7rem', color:'#888'}}>مهرجان</div>
              </div>
            </div>

            {/* SUB TABS NAVIGATION */}
            <div className="sub-tabs">
              <div className={`sub-tab ${activeSubTab === 'warehouse' ? 'active' : ''}`} onClick={() => setActiveSubTab('warehouse')}>
                 🗄️ مخزن المهرجانات
              </div>
              <div className={`sub-tab ${activeSubTab === 'submissions' ? 'active' : ''}`} onClick={() => setActiveSubTab('submissions')}>
                 🎬 ملف المشاركات الجارية
              </div>
            </div>

            <div style={{display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 25}}>
              
              {/* === VIEW 1: WAREHOUSE (No Video Linked) === */}
              {activeSubTab === 'warehouse' && (
                <div className="card">
                  <h3 style={{marginBottom: 20, display:'flex', alignItems:'center', gap:10}}>
                    <Archive size={20} color="var(--primary)"/> مخزن المهرجانات العامة
                  </h3>
                  {sortFestivals(warehouseFestivals).map(fest => {
                    const daysLeft = calculateDaysRemaining(fest.deadline_date);
                    return (
                      <div key={fest.id} className="festival-card" style={{borderLeft: '4px solid #555'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                          <div>
                            <h4 style={{margin: 0, fontSize: '1.1rem'}}>{fest.festival_name}</h4>
                            <div style={{fontSize: '0.85rem', color: '#888', marginTop: 5}}>
                               📅 الموعد القادم: {getEffectiveDeadline(fest.deadline_date)?.toLocaleDateString()} 
                               <span style={{marginLeft:10, color: daysLeft < 30 ? '#FCA5A5' : '#4ADE80'}}>({daysLeft} يوم متبقي)</span>
                            </div>
                            {fest.country && <div style={{fontSize:'0.75rem', color:'#aaa', marginTop:3}}><Globe2 size={12}/> {fest.country} | {fest.category}</div>}
                          </div>
                          <div style={{display: 'flex', gap: 10}}>
                             <button className="btn-icon" onClick={() => moveToSubmission(fest)} style={{background:'rgba(249, 115, 22, 0.2)', color: 'var(--primary)', width:'auto', padding:'5px 12px', borderRadius:'6px', fontSize:'0.8rem', gap:5}}>
                               <PlayCircle size={16}/> شارك بفيلم
                             </button>
                             <button className="btn-icon btn-danger" onClick={() => deleteFestival(fest.id)}><Trash2 size={18}/></button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {warehouseFestivals.length === 0 && <p style={{color: '#666', textAlign: 'center'}}>المخزن فارغ.</p>}
                </div>
              )}

              {/* === VIEW 2: ACTIVE SUBMISSIONS (Video Linked) === */}
              {activeSubTab === 'submissions' && (
                <div className="card">
                  <h3 style={{marginBottom: 20, display:'flex', alignItems:'center', gap:10}}>
                    <Film size={20} color="var(--primary)"/> المشاركات الفعلية
                  </h3>
                  {sortFestivals(activeSubmissions).map(fest => {
                    const daysLeft = calculateDaysRemaining(fest.deadline_date);
                    const isEditing = editingFestivalId === fest.id;
                    const statusInfo = getStatusLabel(fest.status);
                    const linkedVideo = videos.find(v => v.id === fest.video_id);

                    return (
                      <div key={fest.id} className={`festival-card status-${fest.status.replace(' ','-')}`} style={{opacity: (fest.status === 'Rejected' || fest.status === 'Selected') ? 0.6 : 1}}>
                        {!isEditing ? (
                          <>
                            <div style={{flex: 1}}>
                              <div style={{display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 5}}>
                                <h4 style={{margin: 0, fontSize: '1.1rem'}}>{fest.festival_name}</h4>
                                <span style={{fontSize:'0.75rem', color: statusInfo.color, border:`1px solid ${statusInfo.color}`, padding:'2px 8px', borderRadius:10}}>
                                  {statusInfo.text}
                                </span>
                              </div>
                              
                              <div style={{marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6, color: '#fff', fontWeight: 'bold', fontSize: '0.9rem'}}>
                                 <Film size={14} color="var(--primary)"/> 
                                 {linkedVideo ? getLocalizedTitle(linkedVideo.title) : <span style={{color: '#666'}}>--</span>}
                              </div>

                              <div style={{fontSize: '0.85rem', color: '#888', display:'flex', gap: 15, alignItems:'center'}}>
                                 {/* هنا نعرض التاريخ المخزن للمشاركة لأنه تاريخ تاريخي، أو يمكن استخدام getEffectiveDeadline إذا أردت الموعد القادم أيضاً */}
                                 <span>📅 {getEffectiveDeadline(fest.deadline_date)?.toLocaleDateString()}</span>
                                 <span>💰 {fest.cost} {fest.currency}</span>
                                 {fest.platform_url && <a href={fest.platform_url} target="_blank" rel="noreferrer" style={{color: 'var(--primary)', display:'inline-flex', alignItems:'center', gap:4, textDecoration:'none'}}>رابط <ExternalLink size={12}/></a>}
                              </div>

                              {fest.notes && (
                                <div style={{fontSize:'0.85rem', color:'#ccc', background:'rgba(255,255,255,0.05)', padding:'8px', marginTop:'8px', borderRadius:'6px', borderRight:'3px solid var(--primary)', whiteSpace: 'pre-wrap'}}>
                                  {fest.notes}
                                </div>
                              )}
                            </div>

                            <div style={{display: 'flex', gap: 8, alignItems: 'center', marginTop: 10}}>
                               <button className="btn-icon" onClick={() => startEditingFestival(fest)} style={{background:'rgba(255,255,255,0.1)', width: 'auto', padding: '5px 12px', borderRadius: '6px', fontSize: '0.8rem', gap: 5}}>
                                 <Edit2 size={16} /> تعديل
                               </button>
                               <button className="btn-icon btn-danger" onClick={() => deleteFestival(fest.id)}><Trash2 size={18} /></button>
                            </div>
                          </>
                        ) : (
                          <div style={{background:'rgba(0,0,0,0.3)', padding:15, borderRadius:8}}>
                             <h4 style={{marginTop:0, marginBottom:10, color:'var(--primary)'}}>تحديث الحالة</h4>
                             <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10}}>
                               <div>
                                 <label className="label">الحالة</label>
                                 <select className="input" value={editFormData.status} onChange={e => setEditFormData({...editFormData, status: e.target.value})}>
                                   <option value="To Do">مهمة جديدة</option>
                                   <option value="Planning">قيد التجهيز</option>
                                   <option value="Submitted">تم الإرسال</option>
                                   <option value="Pending">بانتظار الرد</option>
                                   <option value="Selected">تم القبول 🏆</option>
                                   <option value="Rejected">مرفوض</option>
                                 </select>
                               </div>
                               <div>
                                 <label className="label">التكلفة</label>
                                 <input type="number" className="input" value={editFormData.cost} onChange={e => setEditFormData({...editFormData, cost: e.target.value})} />
                               </div>
                             </div>
                             <div style={{marginBottom:15}}>
                               <label className="label">ملاحظات</label>
                               <textarea className="input" rows="3" value={editFormData.notes || ''} onChange={e => setEditFormData({...editFormData, notes: e.target.value})}></textarea>
                             </div>
                             <div style={{display:'flex', gap:10}}>
                               <button className="btn btn-primary" onClick={saveFestivalChanges} style={{fontSize:'0.9rem'}}>حفظ</button>
                               <button className="btn btn-secondary" onClick={() => setEditingFestivalId(null)} style={{fontSize:'0.9rem'}}>إلغاء</button>
                             </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                  {activeSubmissions.length === 0 && <p style={{color: '#666', textAlign: 'center'}}>لا توجد مشاركات جارية.</p>}
                </div>
              )}

              {/* Add New Form (Works for both) */}
              <div className="card">
                <h3>{activeSubTab === 'warehouse' ? 'إضافة للمخزن' : 'إضافة مشاركة مباشرة'}</h3>
                <form onSubmit={addFestival}>
                  <div className="input-group">
                    <label className="label">اسم المهرجان</label>
                    <input className="input" value={newFestival.festival_name} onChange={e => setNewFestival({...newFestival, festival_name: e.target.value})} placeholder="مثال: مهرجان البحر الأحمر" required />
                  </div>
                  
                  <div className="input-group">
                    <label className="label">الدولة</label>
                    <input className="input" value={newFestival.country} onChange={e => setNewFestival({...newFestival, country: e.target.value})} placeholder="مثال: السعودية، فرنسا..." />
                  </div>

                  {/* Only show Video Select if not in Warehouse mode, or allow user to leave empty to go to warehouse */}
                  <div className="input-group">
                    <label className="label">الفيلم (اختياري - اتركه فارغاً للإضافة للمخزن)</label>
                    <select className="input" value={newFestival.video_id} onChange={e => setNewFestival({...newFestival, video_id: e.target.value})}>
                      <option value="">-- مخزن المهرجانات (بدون فيلم) --</option>
                      {videos.map(v => <option key={v.id} value={v.id}>{getLocalizedTitle(v.title)}</option>)}
                    </select>
                  </div>

                  <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:10}}>
                    <div className="input-group">
                      <label className="label">بداية التسجيل</label>
                      <input type="date" className="input" value={newFestival.registration_start_date} onChange={e => setNewFestival({...newFestival, registration_start_date: e.target.value})} />
                    </div>
                    <div className="input-group">
                      <label className="label">نهاية التسجيل (Deadline)</label>
                      <input type="date" className="input" value={newFestival.deadline_date} onChange={e => setNewFestival({...newFestival, deadline_date: e.target.value})} required />
                    </div>
                  </div>

                  <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:10}}>
                    <div className="input-group">
                      <label className="label">حالة التقديم</label>
                      <select className="input" value={newFestival.status} onChange={e => setNewFestival({...newFestival, status: e.target.value})}>
                        <option value="To Do">مهمة جديدة (To Do)</option>
                        <option value="Planning">قيد التجهيز</option>
                        <option value="Submitted">تم الإرسال</option>
                        <option value="Pending">بانتظار الرد</option>
                        <option value="Selected">تم القبول (Selected)</option>
                        <option value="Rejected">مرفوض (Rejected)</option>
                      </select>
                    </div>
                      <div className="input-group">
                      <label className="label">التكلفة المتوقعة</label>
                      <input type="number" className="input" value={newFestival.cost} onChange={e => setNewFestival({...newFestival, cost: e.target.value})} placeholder="0" />
                    </div>
                  </div>

                  <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:10}}>
                    <div className="input-group">
                      <label className="label">التصنيف</label>
                      <select className="input" value={newFestival.category} onChange={e => setNewFestival({...newFestival, category: e.target.value})}>
                        <option value="Global Class A">عالمي (فئة أ)</option>
                        <option value="International">دولي</option>
                        <option value="Regional">إقليمي</option>
                        <option value="Local">محلي</option>
                      </select>
                    </div>
                    <div className="input-group">
                      <label className="label">رابط التقديم المباشر</label>
                      <input className="input" value={newFestival.platform_url} onChange={e => setNewFestival({...newFestival, platform_url: e.target.value})} placeholder="https://filmfreeway.com/..." />
                    </div>
                  </div>

                  <button className="btn btn-primary" style={{width: '100%'}}>
                     {newFestival.video_id ? 'جدولة المشاركة' : 'إضافة للمخزن'}
                  </button>
                </form>
              </div>

            </div>
          </div>
        )}

        {/* ... (Sections Tab) ... */}
        {activeTab === 'sections' && (
          <div className="animate-fade-in">
            <h1>ترتيب ومحتوى الأقسام</h1>
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20 }}>
              <div className="card">
                <h3 style={{ marginBottom: 20 }}>الأقسام الحالية (اسحب لترتيبها)</h3>
                {data.sections_config.map((section, index) => (
                  <div key={section.id} className="section-item">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ fontWeight: 'bold' }}>{section.titles?.ar || section.title}</span>
                      <span className={`section-badge ${section.type === 'core' ? 'badge-core' : 'badge-custom'}`}>
                        {section.type === 'core' ? 'أساسي' : 'مخصص'}
                      </span>
                    </div>
                    <div style={{ display: 'flex', gap: 5 }}>
                      <button className="btn-icon btn-secondary" onClick={() => moveSection(index, 'up')} disabled={index === 0}><ArrowUp size={16}/></button>
                      <button className="btn-icon btn-secondary" onClick={() => moveSection(index, 'down')} disabled={index === data.sections_config.length - 1}><ArrowDown size={16}/></button>
                      <button className="btn-icon" style={{ background: section.visible ? 'rgba(34,197,94,0.2)' : 'rgba(255,255,255,0.1)', color: section.visible ? '#22C55E' : '#777' }} onClick={() => toggleSection(index)}>
                        <Eye size={16}/>
                      </button>
                      {section.type === 'custom' && (
                        <button className="btn-icon btn-danger" onClick={() => deleteCustomSection(index)}><Trash2 size={16}/></button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="card">
                <h3>إضافة قسم جديد</h3>
                
                {/* --- UPDATE: Enabled Auto Translate for Section Title --- */}
                <TransField 
                  label="عنوان القسم المخصص" 
                  fieldKey="title" 
                  data={newSection.titles} 
                  onChange={handleSectionTransChange} 
                  isObject={true} 
                  onAutoTranslate={(text) => handleSectionAutoTranslate(text, 'title')}
                />

                <div className="input-group">
                  <label className="label">نوع القسم</label>
                  <select className="input" value={newSection.type} onChange={e => setNewSection({...newSection, type: e.target.value})}>
                    <option value="text_image">نص + صورة</option>
                    <option value="text_only">نص فقط (فقرة)</option>
                    <option value="video">فيديو مميز</option>
                  </select>
                </div>
                
                {(newSection.type === 'text_image' || newSection.type === 'text_only') && (
                  /* --- UPDATE: Enabled Auto Translate for Section Content --- */
                  <TransField 
                    label="محتوى القسم المخصص" 
                    fieldKey="content" 
                    data={newSection.contents} 
                    onChange={handleSectionTransChange} 
                    multiline={true} 
                    isObject={true} 
                    onAutoTranslate={(text) => handleSectionAutoTranslate(text, 'content')}
                  />
                )}

                {newSection.type === 'text_image' && (
                  <div className="input-group"><label className="label">رابط الصورة</label><input className="input" value={newSection.image_url} onChange={e => setNewSection({...newSection, image_url: e.target.value})} /></div>
                )}
                {newSection.type === 'video' && (
                  <div className="input-group"><label className="label">رابط الفيديو</label><input className="input" value={newSection.video_url} onChange={e => setNewSection({...newSection, video_url: e.target.value})} /></div>
                )}
                <button className="btn btn-primary" style={{ width: '100%' }} onClick={addCustomSection}>إضافة القسم</button>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'news' && (
          <div className="animate-fade-in">
            <h1>إدارة الأخبار المترجمة</h1>
            <div className="card">
              <form onSubmit={addNews}>
                {/* --- UPDATE: Enabled Auto Translate for News Title --- */}
                <TransField 
                  label="عناوين الخبر" 
                  fieldKey="title" 
                  data={newNews.titles} 
                  onChange={handleNewsTransChange} 
                  isObject={true} 
                  onAutoTranslate={(text) => handleNewsAutoTranslate(text, 'title')}
                />
                
                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:20, marginBottom:10}}>
                   <div className="input-group"><label className="label">رابط الصورة</label><input className="input" value={newNews.image_url} onChange={e=>setNewNews({...newNews, image_url:e.target.value})} /></div>
                   <div className="input-group"><label className="label">التصنيف</label><input className="input" value={newNews.category} onChange={e=>setNewNews({...newNews, category:e.target.value})} /></div>
                </div>

                {/* --- UPDATE: Enabled Auto Translate for News Content --- */}
                <TransField 
                  label="تفاصيل الخبر" 
                  fieldKey="content" 
                  data={newNews.contents} 
                  onChange={handleNewsTransChange} 
                  multiline={true} 
                  isObject={true} 
                  onAutoTranslate={(text) => handleNewsAutoTranslate(text, 'content')}
                />
                
                <button className="btn btn-primary" style={{marginTop:15}}>نشر الخبر بجميع اللغات</button>
              </form>
            </div>
            
            <div style={{display:'flex', flexDirection:'column', gap:15}}>
               {news.map(n => (
                 <div key={n.id} style={{display:'flex', gap:15, background:'rgba(0,0,0,0.2)', padding:15, borderRadius:12, border:'1px solid var(--border)'}}>
                   <img src={n.image_url} style={{width:80, height:80, objectFit:'cover', borderRadius:8}} alt="" />
                   <div style={{flex:1}}>
                     <h3 style={{margin:0}}>{getLocalizedTitle(n.title)}</h3>
                     <p style={{fontSize:'0.8rem', color:'#999', margin:'5px 0'}}>{(getLocalizedTitle(n.content) || '').substring(0, 100)}...</p>
                   </div>
                   <button className="btn-icon btn-danger" onClick={()=>deleteNews(n.id)}><Trash2 size={16}/></button>
                 </div>
               ))}
            </div>
          </div>
        )}

        {/* --- Media Tab (UPDATED) --- */}
        {activeTab === 'media' && (
          <div className="animate-fade-in">
            <h1>إدارة معرض الأعمال</h1>
            <div className="card">
              <h3 style={{marginBottom:15}}>إضافة فيديو جديد</h3>
              <form onSubmit={addVideo}>
                <TransField label="عنوان العمل" fieldKey="title" data={newVideo.titles} onChange={handleVideoTransChange} isObject={true} onAutoTranslate={(text) => handleVideoAutoTranslate(text, 'title')} />
                
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 15, marginTop: 10 }}>
                  <div className="input-group" style={{position:'relative'}}>
                    <label className="label"><Film size={14}/> رابط الفيديو (URL) أو كود التضمين (Embed Code)</label>
                    <input className="input" style={{paddingLeft:40}} value={newVideo.video_url} onChange={e=>setNewVideo({...newVideo, video_url:e.target.value})} placeholder="YouTube / Vimeo URL ... OR <iframe...>" required />
                    <button type="button" className="fetch-btn" onClick={fetchMetadata} title="جلب المعلومات تلقائياً">
                      <Wand2 size={12} /> جلب
                    </button>
                  </div>
                  <div className="input-group"><label className="label"><ImageIcon size={14}/> الصورة المصغرة (Thumbnail)</label><input className="input" value={newVideo.thumbnail_url} onChange={e=>setNewVideo({...newVideo, thumbnail_url:e.target.value})} placeholder="اختياري (يتم جلبها تلقائياً)" /></div>
                </div>

                <div style={{ background: 'rgba(0,0,0,0.2)', padding: 15, borderRadius: 10, marginTop: 10 }}>
                  <h4 style={{ margin: '0 0 15px 0', color: 'var(--primary)', fontSize: '0.9rem' }}>تفاصيل صفحة العمل (Project Page)</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 15 }}>
                    {/* --- UPDATE: Director Field (Multi-Language) --- */}
                    <div style={{gridColumn: '1/3'}}>
                         <TransField label="المخرج" fieldKey="director" data={newVideo.directors} onChange={handleVideoDirectorChange} isObject={true} onAutoTranslate={(text) => handleVideoDirectorAutoTranslate(text)} />
                    </div>
                    {/* ----------------------------------------------- */}
                    <div className="input-group"><label className="label"><Calendar size={14}/> سنة الإنتاج</label><input className="input" value={newVideo.year} onChange={e=>setNewVideo({...newVideo, year:e.target.value})} placeholder="2025" /></div>
                  </div>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 15 }}>
                      <div className="input-group">
                         <TransField label="التصنيف (Genre)" fieldKey="genre" data={newVideo.genres} onChange={(lang, k, val) => setNewVideo(prev => ({...prev, genres: {...prev.genres, [lang]: val}}))} isObject={true} onAutoTranslate={async (text) => {
                            const trans = await executeTranslation(text, 'genre');
                            setNewVideo(prev => ({...prev, genres: {...prev.genres, ...trans}}));
                         }} />
                      </div>
                      <div className="input-group"><label className="label"><ImageIcon size={14}/> بوستر العمل (Poster URL)</label><input className="input" value={newVideo.poster_url} onChange={e=>setNewVideo({...newVideo, poster_url:e.target.value})} placeholder="رابط البوستر الطولي" /></div>
                  </div>

                  {/* --- UPDATE: Description Field (Multi-Language) --- */}
                  <TransField label="قصة العمل (Synopsis)" fieldKey="description" data={newVideo.descriptions} onChange={handleVideoDescriptionChange} multiline={true} isObject={true} onAutoTranslate={(text) => handleVideoDescriptionAutoTranslate(text)} />
                  {/* -------------------------------------------------- */}
                </div>
                <button className="btn btn-primary" style={{marginTop: 20, width: '100%' }} disabled={loading}>
                  {loading ? 'جاري النشر...' : <><Plus size={18}/> نشر العمل</>}
                </button>
              </form>
            </div>

            {/* القائمة القابلة للسحب */}
            <h3 style={{marginTop:30}}>ترتيب الأعمال (اسحب للتغيير)</h3>
            <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:20, marginTop: 10}}>
               {videos.map((v, index) => (
                 <div 
                    key={v.id} 
                    className={`draggable-item ${v.visible === false ? 'item-hidden' : ''}`}
                    draggable 
                    onDragStart={(e) => onDragStart(e, index)}
                    onDragEnter={(e) => onDragEnter(e, index)}
                    onDragEnd={onDragEnd}
                    onDragOver={(e) => e.preventDefault()}
                 >
                   <div style={{position:'relative'}}>
                     <img src={v.thumbnail_url || `https://img.youtube.com/vi/${v.video_url.split('v=')[1]?.split('&')[0]}/hqdefault.jpg`} style={{width:'100%', height:160, objectFit:'cover'}} alt="" />
                     
                     {/* أزرار التحكم العلوية */}
                     <div className="visibility-btn" onClick={() => toggleVisibility(v.id, v.visible !== false)}>
                        {v.visible !== false ? <Eye size={16}/> : <EyeOff size={16}/>}
                     </div>
                     <div style={{position:'absolute', top:10, left:10, background:'rgba(0,0,0,0.6)', padding:5, borderRadius:'50%', cursor:'grab'}}>
                        <GripVertical size={16} color="white"/>
                     </div>
                   </div>

                   <div style={{padding:15}}>
                     <h4 style={{margin:'0 0 5px 0', fontSize:'1rem'}}>{getLocalizedTitle(v.title)}</h4>
                     <p style={{fontSize:'0.7rem', color:'#777', margin:0}}>{getLocalizedTitle(v.director) || v.director} | {v.year}</p>
                     
                     <div style={{display:'flex', justifyContent:'space-between', marginTop: 15, borderTop:'1px solid rgba(255,255,255,0.1)', paddingTop:10}}>
                       <div style={{display:'flex', gap:5}}>
                         <button className="btn-icon" onClick={()=>duplicateVideo(v)} title="نسخ البيانات للتكرار"><Copy size={16}/></button>
                         <button className="btn-icon" onClick={()=>copyDirectLink('video', v.id)} title="نسخ رابط المشاركة"><LinkIcon size={16}/></button>
                       </div>
                       <div style={{display:'flex', gap:5, alignItems:'center'}}>
                         <span style={{fontSize:'0.7rem', color:'#555'}}><Eye size={12}/> {v.views}</span>
                         <button className="btn-icon btn-danger" onClick={()=>deleteVideo(v.id)}><Trash2 size={16}/></button>
                       </div>
                     </div>
                   </div>
                 </div>
               ))}
            </div>
          </div>
        )}

        {/* --- Content Tab --- */}
        {activeTab === 'content' && (
          <div className="animate-fade-in">
            <h1>اللغات والمحتوى الذكي</h1>
            
             {/* --- Default Language Setting --- */}
            <div className="card" style={{ marginBottom: 25, borderRight: '4px solid var(--primary)' }}>
               <h3 style={{ marginBottom: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                 <Globe size={24} color="var(--primary)" />
                 اللغة الافتراضية للموقع
               </h3>
               <div className="input-group">
                 <label className="label">اختر اللغة التي ستظهر للزوار الجدد:</label>
                 <select 
                   className="input" 
                   value={data.default_language || 'ar'} 
                   onChange={e => setData({ ...data, default_language: e.target.value })}
                 >
                   <option value="ar">العربية (Arabic)</option>
                   <option value="en">الإنجليزية (English)</option>
                   <option value="fr">الفرنسية (French)</option>
                   <option value="de">الألمانية (German)</option>
                   <option value="es">الإسبانية (Spanish)</option>
                 </select>
                 <small style={{ color: '#888', marginTop: 5, display: 'block' }}>
                   ملاحظة: هذا الخيار يؤثر فقط على الزوار الجدد. الزوار السابقون سيشاهدون آخر لغة اختاروها.
                 </small>
               </div>
            </div>

            {/* --- Cinematic Intro Settings --- */}
            <div className="card" style={{ marginBottom: 25, borderRight: '4px solid #F97316' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, paddingBottom: 15, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 10, fontSize: '1.2rem', color: '#fff' }}>
                  <Clapperboard size={24} color="#F97316" />
                  المقدمة السينمائية (Intro Sequence)
                </h3>
                <label className="switch">
                  <input 
                    type="checkbox" 
                    checked={data.intro_visible === undefined ? true : data.intro_visible} 
                    onChange={e => setData({ ...data, intro_visible: e.target.checked })}
                  />
                  <span className="slider"></span>
                </label>
              </div>

              {data.intro_visible && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 20 }}>
                  <div className="input-group">
                    <label className="label">نص الترحيب (Intro Text)</label>
                    <input 
                      type="text" 
                      className="input" 
                      value={data.intro_text || ''} 
                      onChange={e => setData({ ...data, intro_text: e.target.value })}
                      placeholder="مثال: Welcome to AMALCO"
                    />
                  </div>
                  
                  <div className="input-group">
                    <label className="label">مدة العرض (مللي ثانية)</label>
                    <input 
                      type="number" 
                      className="input" 
                      value={data.intro_duration || 3500} 
                      onChange={e => setData({ ...data, intro_duration: parseInt(e.target.value) })}
                      placeholder="3500"
                    />
                    <small style={{ color: '#666', marginTop: 5, fontSize: '0.8rem' }}>1000 = 1 ثانية (الافتراضي 3500)</small>
                  </div>

                  <div className="input-group" style={{ gridColumn: '1 / -1' }}>
                    <label className="label">رابط شعار المقدمة (اختياري)</label>
                    <div style={{ display: 'flex', gap: 10 }}>
                      <input 
                        type="text" 
                        className="input" 
                        value={data.intro_logo_url || ''} 
                        onChange={e => setData({ ...data, intro_logo_url: e.target.value })}
                        placeholder="https://example.com/logo-white.png"
                      />
                      {data.intro_logo_url && <img src={data.intro_logo_url} alt="Preview" style={{ height: 40, borderRadius: 5, background: '#333' }} />}
                    </div>
                    <small style={{ color: '#666', marginTop: 5, fontSize: '0.8rem' }}>يفضل استخدام صورة PNG شفافة وشعار باللون الأبيض</small>
                  </div>
                </div>
              )}
            </div>

            <div className="card">
              <Accordion title="1. القائمة العلوية (Navbar)">
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                  {/* --- UPDATE: Enabled Auto Translate for Menu Items --- */}
                  <TransField label="الرئيسية" fieldKey="menu.home" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'menu.home')} />
                  <TransField label="أعمالنا" fieldKey="menu.portfolio" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'menu.portfolio')} />
                  <TransField label="من نحن" fieldKey="menu.about" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'menu.about')} />
                  <TransField label="الأخبار" fieldKey="menu.news" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'menu.news')} />
                  <TransField label="تواصل معنا" fieldKey="menu.contact" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'menu.contact')} />
                </div>
              </Accordion>
              <Accordion title="2. قسم الترحيب (Hero)">
                <TransField label="العنوان الرئيسي" fieldKey="heroTitle" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'heroTitle')} />
                <TransField label="الوصف الفرعي" fieldKey="heroSubtitle" data={data} onChange={handleMatrixChange} multiline onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'heroSubtitle')} />
                <TransField label="زر المشاهدة" fieldKey="heroPortfolioBtn" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'heroPortfolioBtn')} />
              </Accordion>
              <Accordion title="3. قسم من نحن (About)">
                <TransField label="العنوان" fieldKey="aboutTitle" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'aboutTitle')} />
                <TransField label="النص التعريفي" fieldKey="aboutText" data={data} onChange={handleMatrixChange} multiline onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'aboutText')} />
                <TransField label="زر الملف الصحفي" fieldKey="pressKitBtn" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'pressKitBtn')} />
              </Accordion>
              <Accordion title="4. قسم الأخبار (News)">
                <TransField label="عنوان القسم" fieldKey="newsTitle" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'newsTitle')} />
              </Accordion>
              <Accordion title="5. الفوتر (Footer)">
                <TransField label="عنوان التواصل" fieldKey="contactTitle" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'contactTitle')} />
                <TransField label="النص التشجيعي" fieldKey="contactText" data={data} onChange={handleMatrixChange} multiline onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'contactText')} />
                <TransField label="زر الإرسال" fieldKey="contactBtn" data={data} onChange={handleMatrixChange} onAutoTranslate={(text) => handleGeneralAutoTranslate(text, 'contactBtn')} />
              </Accordion>
            </div>
          </div>
        )}

        {/* --- Branding Tab --- */}
        {activeTab === 'branding' && (
          <div className="animate-fade-in">
            <h1>الهوية البصرية والروابط</h1>
            <div className="card">
              <h3 style={{color:'var(--primary)', marginBottom:15}}>ألوان الموقع</h3>
              <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:15}}>
                <div className="input-group"><label className="label">اللون الأساسي</label><div style={{display:'flex', gap:10}}><input type="color" value={data.primary_color} onChange={e=>setData({...data, primary_color:e.target.value})} /><input className="input" value={data.primary_color} onChange={e=>setData({...data, primary_color:e.target.value})} /></div></div>
                <div className="input-group"><label className="label">لون الخلفية</label><div style={{display:'flex', gap:10}}><input type="color" value={data.bg_color} onChange={e=>setData({...data, bg_color:e.target.value})} /><input className="input" value={data.bg_color} onChange={e=>setData({...data, bg_color:e.target.value})} /></div></div>
                <div className="input-group"><label className="label">لون الهيدر</label><input className="input" value={data.header_bg_color} onChange={e=>setData({...data, header_bg_color:e.target.value})} /></div>
                <div className="input-group"><label className="label">لون الفوتر</label><input className="input" value={data.footer_bg_color} onChange={e=>setData({...data, footer_bg_color:e.target.value})} /></div>
              </div>
            </div>
            <div className="card">
              <h3 style={{color:'var(--primary)', marginBottom:15}}>إعدادات المتصفح والفوتر</h3>
              <div className="input-group"><label className="label">عنوان التبويب (SEO Title)</label><input className="input" value={data.seo_title || ''} onChange={e=>setData({...data, seo_title:e.target.value})} /></div>
              <div className="input-group"><label className="label">رابط الأيقونة (Favicon)</label><input className="input" value={data.favicon_url || ''} onChange={e=>setData({...data, favicon_url:e.target.value})} /></div>
              <div className="input-group"><label className="label">حقوق الملكية</label><input className="input" value={data.copyright_text || ''} onChange={e=>setData({...data, copyright_text:e.target.value})} /></div>
            </div>
            <div className="card">
              <h3 style={{color:'var(--primary)', marginBottom:15}}>الصور والروابط</h3>
              <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:15}}>
                <div className="input-group"><label className="label">رابط الشعار</label><input className="input" value={data.logo_url} onChange={e=>setData({...data, logo_url:e.target.value})} /></div>
                <div className="input-group"><label className="label">خلفية الهيرو</label><input className="input" value={data.hero_background_url} onChange={e=>setData({...data, hero_background_url:e.target.value})} /></div>
                <div className="input-group"><label className="label">صورة من نحن</label><input className="input" value={data.about_image_url} onChange={e=>setData({...data, about_image_url:e.target.value})} /></div>
                <div className="input-group"><label className="label">ملف Press Kit</label><input className="input" value={data.press_kit_url} onChange={e=>setData({...data, press_kit_url:e.target.value})} /></div>
              </div>
            </div>
            <div className="card">
              <h3 style={{color:'var(--primary)', marginBottom:15}}>التواصل والسوشيال ميديا</h3>
              <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:15}}>
                <input className="input" placeholder="Email" value={data.contact_email} onChange={e=>setData({...data, contact_email:e.target.value})} />
                <input className="input" placeholder="Phone" value={data.contact_phone} onChange={e=>setData({...data, contact_phone:e.target.value})} />
                <input className="input" placeholder="Facebook" value={data.social_facebook} onChange={e=>setData({...data, social_facebook:e.target.value})} />
                <input className="input" placeholder="Instagram" value={data.social_instagram} onChange={e=>setData({...data, social_instagram:e.target.value})} />
                <input className="input" placeholder="Twitter" value={data.social_twitter} onChange={e=>setData({...data, social_twitter:e.target.value})} />
                <input className="input" placeholder="YouTube" value={data.social_youtube} onChange={e=>setData({...data, social_youtube:e.target.value})} />
                <input className="input" placeholder="TikTok" value={data.social_tiktok} onChange={e=>setData({...data, social_tiktok:e.target.value})} />
                <input className="input" placeholder="LinkedIn" value={data.social_linkedin} onChange={e=>setData({...data, social_linkedin:e.target.value})} />
              </div>
            </div>
          </div>
        )}

        {/* --- Partners Tab --- */}
        {activeTab === 'partners' && (
          <div className="animate-fade-in">
            <h1>إدارة شركاء النجاح والجوائز</h1>
            <div className="card" style={{ borderRight: '4px solid #3B82F6' }}>
              <h3 style={{ color: '#3B82F6', display: 'flex', alignItems: 'center', gap: 10, marginBottom: 15 }}>
                <Award size={22} /> إضافة شريك أو جائزة جديدة
              </h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr auto', gap: 10, alignItems: 'end', marginBottom: 20 }}>
                <div className="input-group" style={{ marginBottom: 0 }}>
                  <label className="label">اسم الجهة/الجائزة</label>
                  <input className="input" placeholder="اسم الشريك" value={newPartner.name} onChange={e => setNewPartner({ ...newPartner, name: e.target.value })} />
                </div>
                <div className="input-group" style={{ marginBottom: 0 }}>
                  <label className="label">رابط الشعار (Logo URL)</label>
                  <input className="input" placeholder="https://..." value={newPartner.logo_url} onChange={e => setNewPartner({ ...newPartner, logo_url: e.target.value })} />
                </div>
                <button className="btn btn-primary" onClick={addPartner}><Plus size={18} /> إضافة</button>
              </div>
              <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 10, padding: 15, maxHeight: 300, overflowY: 'auto' }}>
                {!data.partners_json || data.partners_json.length === 0 ? (
                  <p style={{ color: '#666', textAlign: 'center' }}>لا يوجد شركاء مضافين حالياً.</p>
                ) : (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
                    {data.partners_json.map((partner) => (
                      <div key={partner.id} style={{ background: '#1e293b', borderRadius: 8, padding: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, position: 'relative', width: 120 }}>
                        <button 
                          onClick={() => removePartner(partner.id)}
                          style={{ position: 'absolute', top: 5, right: 5, background: 'rgba(239, 68, 68, 0.8)', border: 'none', borderRadius: '50%', width: 20, height: 20, color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                        >
                          <X size={12} />
                        </button>
                        <img src={partner.logo_url} alt={partner.name} style={{ width: 60, height: 60, objectFit: 'contain' }} />
                        <span style={{ fontSize: '0.8rem', textAlign: 'center', color: '#ccc' }}>{partner.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* --- NEW: Subscribers List Tab --- */}
        {activeTab === 'newsletter' && (
          <div className="animate-fade-in">
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
              <h1>القائمة البريدية</h1>
              <button className="btn btn-primary" onClick={downloadSubscribersCSV} style={{background: '#22C55E', color: 'white'}}>
                <Download size={18} /> تصدير إلى Excel (CSV)
              </button>
            </div>
            
            <div className="card">
              <div style={{display:'flex', alignItems:'center', gap:10, marginBottom:15}}>
                <Users2 size={24} color="var(--primary)" />
                <h3 style={{margin:0}}>المشتركون في النشرة ({subscribers.length})</h3>
              </div>
              
              {subscribers.length === 0 ? (
                <p style={{textAlign:'center', padding:20, color:'#888'}}>لا يوجد مشتركين حتى الآن.</p>
              ) : (
                <div style={{overflowX: 'auto'}}>
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th width="50">#</th>
                        <th>البريد الإلكتروني</th>
                        <th>تاريخ الاشتراك</th>
                        <th width="80">إجراءات</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subscribers.map((sub, index) => (
                        <tr key={sub.id}>
                          <td style={{textAlign:'center', color:'#666'}}>{index + 1}</td>
                          <td>{sub.email}</td>
                          <td>{new Date(sub.created_at).toLocaleDateString()} <span style={{fontSize:'0.8rem', color:'#666'}}>{new Date(sub.created_at).toLocaleTimeString()}</span></td>
                          <td style={{textAlign:'center'}}>
                            <button className="btn-icon btn-danger" onClick={() => deleteSubscriber(sub.id)} title="حذف المشترك">
                              <Trash2 size={16} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === 'inbox' && (
          <div className="animate-fade-in">
            <h1>صندوق الرسائل</h1>
            <div style={{display:'flex', flexDirection:'column', gap:15}}>
              {messages.length === 0 ? <p>لا توجد رسائل.</p> : messages.map(msg => (
                <div key={msg.id} style={{background:'rgba(255,255,255,0.03)', padding:20, borderRadius:12, border:'1px solid var(--border)'}}>
                  <div style={{display:'flex', justifyContent:'space-between', marginBottom:10}}>
                    <div><strong>{msg.sender_name}</strong><div style={{fontSize:'0.8rem', color:'var(--primary)'}}>{msg.sender_email}</div></div>
                    <button className="btn-icon btn-danger" onClick={()=>deleteMessage(msg.id)}><Trash2 size={16}/></button>
                  </div>
                  <p style={{margin:0, color:'#ddd'}}>{msg.message_content}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'security' && (
          <div className="animate-fade-in">
            <h1>الأمان والدخول</h1>
            <div className="card" style={{ maxWidth: 500 }}>
              <h3 style={{ marginBottom: 20 }}>تغيير كلمة مرور الإدارة</h3>
              <form onSubmit={changePassword}>
                <div className="input-group"><label className="label">كلمة المرور الحالية</label><input type="password" className="input" value={passData.old} onChange={e=>setPassData({...passData, old:e.target.value})} required /></div>
                <div className="input-group"><label className="label">كلمة المرور الجديدة</label><input type="password" className="input" value={passData.new} onChange={e=>setPassData({...passData, new:e.target.value})} required /></div>
                <div className="input-group"><label className="label">تأكيد الجديدة</label><input type="password" className="input" value={passData.confirm} onChange={e=>setPassData({...passData, confirm:e.target.value})} required /></div>
                <button className="btn btn-primary" style={{ width: '100%' }}>تحديث كلمة المرور</button>
              </form>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}